<template>
    <div class="lang-selector" v-click-outside="hideLangSelector"> 
        <div class="lang-selector__selected-lang" @click="showLang = !showLang">{{ selectedLanguage.name}}</div>     
        <div class="lang-selector__selector-wrap" :class="{'active': showLang}">
            <div v-for ="lang in langObject.languages" :key="lang.id" class="lang-selector__item form-check" :class="{'selected': ( lang.id == selectedLanguage.id)}" @click="showLang = false">
                <input class="form-check-input" type="radio" :id="lang.id" :value="lang.id" v-model="selectedLangId" >
                <label class="form-check-label" :for="lang.id" @click="setNewSelectLang(lang.id)">{{lang.name}}</label>
            </div>
            <div class="lang-selector__item form-check"><a href="https://www.univer.ro/" class="form-check-label">ro</a></div>
        </div>        
    </div>
</template>

<script>
export default {
    data(){
        return {   
            showLang: false,
            selectedLangId: '',
            selectedLanguage: {
                name: null,
                id: null
            }                
        }
    },    
    computed:{        
        langObject: function(){
            return this.$store.getters.getLang;                 
        }
    }, 
    watch:{        
        langObject: {
            deep: true,
            immediate: true,
            handler(){                
                this.setSelectedLang();                               
            }
        }
    },
    created(){
        this.setSelectedLang();   
    },
    methods:{  
        setSelectedLang(){            
           
            var _this = this; 
            var defLangId = _this.langObject.defLang.id                      
            
            if (_this.langObject.languages.length > 0){                
                if ( this.$store.getters.getSelectedLang.id == null) {                    
                     _this.langObject.languages.find( item => {            
                        if (parseInt(item.id ) === parseInt(defLangId)) {                
                            _this.selectedLangId = item.id;  
                            _this.selectedLanguage.id = item.id
                            _this.selectedLanguage.name = item.name.toLowerCase()
                             this.$store.dispatch("setLang", {lang: item} );
                        }                            
                    })
                } else {          
                    //there was a selected lang
                    _this.selectedLanguage.id = _this.langObject.selectedLang.id
                    _this.selectedLanguage.name = _this.langObject.selectedLang.name
                    _this.selectedLangId = _this.langObject.selectedLang.id
                }
            }                            
        }, 
        setNewSelectLang(newLang){       
            let _this = this             

            if ( newLang != this.selectedLangId){
                this.langObject.languages.find( item =>{
                    if ( parseInt(item.id) === parseInt(newLang)) {
                        _this.selectedLangId = item.id
                        _this.selectedLanguage.id = item.id
                        _this.selectedLanguage.name = item.name.toLowerCase()
                        this.$store.dispatch("setLang", {lang: item, fgv: this.goToMainPage} );
                    } 
                })                                   
            }            
                                                               
            //hide the language selector
            this.showLang = false;
        },  
        goToMainPage(){                                 
            var _this = this;             
            //throw to the main page and change the lang                                              

            this.$router.push({                                        
                path: '/' +_this.selectedLanguage.name.toLowerCase()
            }).then( () => {                                                   
                this.$router.go()
            })  
        },               
        hideLangSelector(){                    
            this.showLang = false
        }       
    }   
}
</script>